import get from 'lodash/get';
import actionTypes, {
  asyncActionTypeFailure,
  asyncActionTypeRequest,
  asyncActionTypeSuccess,
} from './actionTypes';

const initialState = {
  inspectionJobs: {
    filtered: {
      result: ['all'],
      status: ['all'],
    },
    sorted: {
      by: 'inspectionDate',
      direction: 'desc',
    },
    search: {
      by: 'productName',
      keywords: '',
    },
    pagination: {
      pageNo: 1,
      pageSize: 10,
    },
    data: [],
    loading: false,
    total: 0,
    error: null,
  },
  inspectionDraftJobs: {
    filtered: {
      result: ['all'],
      status: ['all'],
    },
    sorted: {
      by: 'inspectionDate',
      direction: 'desc',
    },
    search: {
      by: 'productName',
      keywords: '',
    },
    pagination: {
      pageNo: 1,
      pageSize: 10,
    },
    data: {},
    loading: false,
    total: 0,
    error: null,
  },
  inspectionCalendar: {
    filtered: {
      status: ['all'],
      productTags: ['all'],
      inspectors: ['all'],
      locations: ['all'],
    },
    search: {
      by: 'inspectorName',
      keywords: '',
    },
    pagination: {
      pageNo: 1,
      pageSize: 99999,
    },
    data: [],
    error: null,
  },
  inspectionDetail: {
    data: {},
    attachment: {
      data: [],
      pagination: {
        pageNo: 1,
        pageSize: 10,
      },
      total: 0,
    },
    reports: [],
    loading: false,
    error: null,
  },
  inspectors: {
    data: [],
    error: null,
    isLoading: false,
  },
  productTags: {
    data: [],
    pagination: {
      pageNo: 1,
      pageSize: 50,
    },
    keywords: '',
    error: null,
    isLoading: false,
    hasMore: true,
  },
  reportDetail: {
    data: {},
    error: null,
    loading: false,
  },
  validateData: {},
  thirdPartyServiceProviders: {
    data: [],
    error: '',
    loading: false,
  },
};

export default (state = initialState, action) => {
  switch (action.type) {
    // GET GET_INSPECTION_3PARTY_SERVICE_PROVIDERS
    case asyncActionTypeRequest(actionTypes.GET_INSPECTION_3PARTY_SERVICE_PROVIDERS): {
      return {
        ...state,
        thirdPartyServiceProviders: {
          ...state.thirdPartyServiceProviders,
          loading: true,
          error: '',
        },
      };
    }
    case asyncActionTypeSuccess(actionTypes.GET_INSPECTION_3PARTY_SERVICE_PROVIDERS): {
      return {
        ...state,
        thirdPartyServiceProviders: {
          loading: false,
          data: get(action, 'response.data', []) || [],
          error: '',
        },
      };
    }
    case asyncActionTypeFailure(actionTypes.GET_INSPECTION_3PARTY_SERVICE_PROVIDERS): {
      return {
        ...state,
        thirdPartyServiceProviders: {
          loading: false,
          data: [],
          error: get(action, 'error'),
        },
      };
    }
    // #region GET INSPECTORS
    case asyncActionTypeRequest(actionTypes.GET_INSPECTORS): {
      return {
        ...state,
        inspectors: {
          ...state.inspectors,
          loading: true,
          error: '',
        },
      };
    }
    case asyncActionTypeSuccess(actionTypes.GET_INSPECTORS): {
      return {
        ...state,
        inspectors: {
          loading: false,
          data: get(action, 'response.data.list', []) || [],
          error: '',
        },
      };
    }
    case asyncActionTypeFailure(actionTypes.GET_INSPECTORS): {
      return {
        ...state,
        inspectors: {
          loading: false,
          data: [],
          error: get(action, 'error'),
        },
      };
    }
    // #endregion
    // #region GET PRODUCT TAGS
    case asyncActionTypeRequest(actionTypes.GET_PRODUCT_TAGS): {
      return {
        ...state,
        productTags: {
          ...state.productTags,
          pagination: action.payload.pagination,
          keywords: action.payload.keywords,
          loading: true,
          error: '',
        },
      };
    }
    case asyncActionTypeSuccess(actionTypes.GET_PRODUCT_TAGS): {
      return {
        ...state,
        productTags: {
          ...state.productTags,
          loading: false,
          data: get(action, 'response') || [],
          error: '',
        },
      };
    }
    case asyncActionTypeFailure(actionTypes.GET_PRODUCT_TAGS): {
      return {
        ...state,
        productTags: {
          ...state.productTags,
          loading: false,
          data: {},
          error: get(action, 'error'),
        },
      };
    }
    // #endregion
    // #region GET INSPECTION JOBS
    case asyncActionTypeRequest(actionTypes.GET_INSPECTION_JOBS): {
      return {
        ...state,
        inspectionJobs: {
          ...state.inspectionJobs,
          loading: true,
          error: '',
        },
      };
    }
    case asyncActionTypeSuccess(actionTypes.GET_INSPECTION_JOBS): {
      return {
        ...state,
        inspectionJobs: {
          ...state.inspectionJobs,
          loading: false,
          data: get(action, 'response.data.list') || [],
          meta: get(action, 'response.data.pagination') || {},
          error: '',
        },
      };
    }
    case asyncActionTypeFailure(actionTypes.GET_INSPECTION_JOBS): {
      return {
        ...state,
        inspectionJobs: {
          ...state.inspectionJobs,
          loading: false,
          data: [],
          meta: {},
          error: get(action, 'error'),
        },
      };
    }
    // #endregion
    // #region GET INSPECTION DRAFT JOBS
    case asyncActionTypeRequest(actionTypes.GET_INSPECTION_DRAFT_JOBS): {
      return {
        ...state,
        inspectionDraftJobs: {
          ...state.inspectionDraftJobs,
          pagination: action.payload.pagination,
          filtered: action.payload.filtered,
          sorted: action.payload.sorted,
          search: action.payload.search,
          loading: true,
          error: '',
        },
      };
    }
    case asyncActionTypeSuccess(actionTypes.GET_INSPECTION_DRAFT_JOBS): {
      return {
        ...state,
        inspectionDraftJobs: {
          ...state.inspectionDraftJobs,
          loading: false,
          data: get(action, 'response.data') || {},
          total: get(action, 'response.data.pagination.total', 0),
          error: '',
        },
      };
    }
    case asyncActionTypeFailure(actionTypes.GET_INSPECTION_DRAFT_JOBS): {
      return {
        ...state,
        inspectionDraftJobs: {
          ...state.inspectionDraftJobs,
          loading: false,
          data: {},
          error: get(action, 'error'),
        },
      };
    }
    // #endregion
    // #region GET INSPECTION INSPECTOR WITH JOBS (CALENDAR)
    case asyncActionTypeRequest(actionTypes.GET_INSPECTION_INSPECTOR_WITH_JOB): {
      return {
        ...state,
        inspectionCalendar: {
          ...state.inspectionCalendar,
          filtered: action.payload.filtered,
          search: action.payload.search,
          data: [],
          loading: true,
          error: '',
        },
      };
    }
    case asyncActionTypeSuccess(actionTypes.GET_INSPECTION_INSPECTOR_WITH_JOB): {
      return {
        ...state,
        inspectionCalendar: {
          ...state.inspectionCalendar,
          loading: false,
          data: get(action, 'response.data.list') || [],
          total: get(action, 'response.data.pagination.total', 0),
          error: '',
        },
      };
    }
    case asyncActionTypeFailure(actionTypes.GET_INSPECTION_INSPECTOR_WITH_JOB): {
      return {
        ...state,
        inspectionCalendar: {
          ...state.inspectionCalendar,
          loading: false,
          data: [],
          error: get(action, 'error'),
        },
      };
    }
    // #endregion
    // #region GET BUYER INSPECTION DETAIL
    case asyncActionTypeRequest(actionTypes.GET_BUYER_INSPECTION_DETAIL): {
      return {
        ...state,
        inspectionDetail: {
          ...state.inspectionDetail,
          data: {},
          loading: true,
          error: '',
        },
      };
    }
    case asyncActionTypeSuccess(actionTypes.GET_BUYER_INSPECTION_DETAIL): {
      return {
        ...state,
        inspectionDetail: {
          ...state.inspectionDetail,
          loading: false,
          data: get(action, 'response.data') || {},
          error: '',
        },
      };
    }
    case asyncActionTypeFailure(actionTypes.GET_BUYER_INSPECTION_DETAIL): {
      return {
        ...state,
        inspectionDetail: {
          ...state.inspectionDetail,
          loading: false,
          data: [],
          error: get(action, 'error'),
        },
      };
    }
    // #endregion
    // #region GET BUYER INSPECTION ATTACHMENTS
    case asyncActionTypeRequest(actionTypes.GET_INSPECTION_ATTACHMENTS): {
      return {
        ...state,
        inspectionDetail: {
          ...state.inspectionDetail,
          attachment: {
            ...state.inspectionDetail.attachment,
            pagination: action.payload,
          },
          loading: true,
          error: '',
        },
      };
    }
    case asyncActionTypeSuccess(actionTypes.GET_INSPECTION_ATTACHMENTS): {
      return {
        ...state,
        inspectionDetail: {
          ...state.inspectionDetail,
          loading: false,
          attachment: {
            ...state.inspectionDetail.attachment,
            data: get(action, 'response.data.list') || [],
            total: get(action, 'response.data.pagination.total', 0),
          },
          error: '',
        },
      };
    }
    case asyncActionTypeFailure(actionTypes.GET_INSPECTION_ATTACHMENTS): {
      return {
        ...state,
        inspectionDetail: {
          ...state.inspectionDetail,
          loading: false,
          attachment: {
            ...state.inspectionDetail.attachment,
            data: [],
          },
          error: get(action, 'error'),
        },
      };
    }
    // #endregion
    // #region GET_INTERNAL_INSPECTION_REPORT_DETAIL
    case asyncActionTypeRequest(actionTypes.GET_INTERNAL_INSPECTION_REPORT_DETAIL): {
      return {
        ...state,
        reportDetail: {
          ...state.reportDetail,
          data: {},
          loading: true,
          error: '',
        },
      };
    }
    case asyncActionTypeSuccess(actionTypes.GET_INTERNAL_INSPECTION_REPORT_DETAIL): {
      return {
        ...state,
        reportDetail: {
          ...state.reportDetail,
          data: get(action, 'response.data') || [],
          loading: false,
          error: '',
        },
      };
    }
    case asyncActionTypeFailure(actionTypes.GET_INTERNAL_INSPECTION_REPORT_DETAIL): {
      return {
        ...state,
        reportDetail: {
          ...state.reportDetail,
          loading: false,
          error: get(action, 'error'),
        },
      };
    }
    // #endregion

    case actionTypes.INSPECTION_JOB_SET_VALIDATE_DATA: {
      return {
        ...state,
        validateData: action.payload,
      };
    }

    case actionTypes.INSPECTION_JOB_RESET_VALIDATE_DATA: {
      return {
        ...state,
        validateData: {},
      };
    }

    default: {
      return state;
    }
  }
};
